import { IExistingDashRegistration, IExistingDonor } from '@nkr/store/index';
import { Form, FormGroup, Panel, Row, Col, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { IValidationConfirmMatch } from './validation';

const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }

    label {
        font-weight: normal;
        margin-bottom: 0px;
    }
`;

interface IProps {
    step: number,
    selectedItemType: string,
    selectedItemId: number,
    existingRegistrations: IExistingDashRegistration[],
    existingDonors: IExistingDonor[],
    dirty: boolean,
    validation: IValidationConfirmMatch,
    onConfirmMatch: (type: string, id: number) => void,
    onPrevious: () => void,
    onContinue: () => void
}

const ConfirmMatch = (props: IProps) => {
    return (
        <>
            <Row>
                <Col xs={12} lg={8} lgOffset={2}>
                    <Panel>
                        <Panel.Heading>Step {props.step} - Email matches found.  Please select the record this follow-up is attached to...</Panel.Heading>
                        <Panel.Body>
                            <TableWrapper condensed striped bordered>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Source</th>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>DoB</th>
                                        <th>Email</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.existingRegistrations.map((item, index) =>
                                        <tr key={'confirm-' + index}>
                                            <td>
                                                <input id={'dashConfirmId-' + item.id} type='radio' name='confirmId' checked={props.selectedItemType == 'DASH' && props.selectedItemId == item.id} onClick={() => props.onConfirmMatch('DASH', item.id)} />
                                            </td>
                                            <td>DASH</td>
                                            <td><label htmlFor={'dashConfirmId-' + item.id}>{item.fullName}</label></td>
                                            <td>
                                                {item.fullName != '' && (
                                                    <div>{item.addressLine1}</div>
                                                )}

                                                {item.city != '' && item.state != '' && item.postalCode != '' && (
                                                    <div>{item.city}, {item.state} {item.postalCode}</div>
                                                )}
                                            </td>
                                            <td>{item.birthDate}</td>
                                            <td>{item.email}</td>
                                        </tr>
                                    )}

                                    {props.existingDonors.map((item, index) =>
                                        <tr key={'confirm-' + index}>
                                            <td>
                                                <input id={'donorConfirmId-' + item.id} type='radio' name='confirmId' checked={props.selectedItemType == 'DONOR' && props.selectedItemId == item.id} onClick={() => props.onConfirmMatch('DONOR', item.id)} />
                                            </td>
                                            <td>NKR Donor</td>
                                            <td><label htmlFor={'donorConfirmId-' + item.id}>{item.fullName}</label></td>
                                            <td>
                                                {item.fullName != '' && (
                                                    <div>{item.addressLine1}</div>
                                                )}

                                                {item.city != '' && item.state != '' && item.postalCode != '' && (
                                                    <div>{item.city}, {item.state} {item.postalCode}</div>
                                                )}
                                            </td>
                                            <td>{item.birthDate}</td>
                                            <td>{item.email}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </TableWrapper>
                        </Panel.Body>
                    </Panel>
                </Col>

            </Row>

            <Row>
                <Col xs={12} lg={8} lgOffset={2}>
                    <FormGroup>
                        <Col xs={12} sm={2}>&nbsp;</Col>
                        <Col xs={12} sm={4}>
                            <button type='button' className='btn btn-default col-xs-12' onClick={props.onPrevious}>Previous Step</button>
                        </Col>
                        <Col xs={12} sm={4}>
                            <button type='button' className='btn btn-primary col-xs-12' onClick={props.onContinue}>Continue</button>
                        </Col>
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}

export default ConfirmMatch;